import { ADMIN_ROLES } from "../auth";

export const routes = {
    "/fastTrackPitPupMedicalForm": {
        title: "Fast Track PIT/PUP Medical Questionnaire",
        authorize: [ADMIN_ROLES.AMAZON_TECHNICIAN_ONLY.name]
    }
};
